var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payMentDetails" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("data.payin_details"),
            visible: _vm.dialogTableVisible,
            width: "680px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
            open: _vm.getDetailInfo,
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "total" }, [
            _c("div", { staticClass: "total-item" }, [
              _c("div", { staticClass: "total-title" }, [
                _vm._v(_vm._s(_vm.$t("data.paid")) + ":"),
              ]),
              _c("div", { staticClass: "total-num" }, [
                _vm._v(
                  _vm._s(_vm.showSourceCurrency) +
                    " " +
                    _vm._s(
                      _vm._f("toDivideWithDot")(
                        _vm.merchantInfo.transaction_amount
                      )
                    )
                ),
              ]),
            ]),
            _vm.$store.getters.isAllCountry
              ? _c("div", { staticClass: "line" })
              : _vm._e(),
            _vm.$store.getters.isAllCountry
              ? _c("div", { staticClass: "total-item" }, [
                  _c("div", { staticClass: "total-title" }, [
                    _vm._v(_vm._s(_vm.$t("data.exchange_rate")) + ":"),
                  ]),
                  _c("div", { staticClass: "total-num" }, [
                    _vm._v(
                      _vm._s(
                        _vm.merchantInfo.source_currency ===
                          _vm.merchantInfo.destination_currency
                          ? "-"
                          : _vm.merchantInfo.mch_rate
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.$store.getters.isAllCountry
              ? _c("div", { staticClass: "line" })
              : _vm._e(),
            _vm.$store.getters.isAllCountry
              ? _c("div", { staticClass: "total-item" }, [
                  _c("div", { staticClass: "total-title" }, [
                    _vm._v(
                      _vm._s(_vm.$t("merchantAccount.settlement_amount")) + ":"
                    ),
                  ]),
                  _c("div", { staticClass: "total-num" }, [
                    _vm._v(
                      _vm._s(_vm.merchantInfo.destination_currency) +
                        " " +
                        _vm._s(
                          _vm._f("toDivideWithDot")(
                            _vm.merchantInfo.destination_amount
                          )
                        )
                    ),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "line" }),
            _c("div", { staticClass: "total-item" }, [
              _c("div", { staticClass: "total-title" }, [
                _vm._v(_vm._s(_vm.$t("data.fee")) + ":"),
              ]),
              _c("div", { staticClass: "total-num" }, [
                _vm._v(
                  _vm._s(_vm.showFeeCurrency) +
                    " " +
                    _vm._s(
                      _vm._f("toDivideWithDot")(_vm.merchantInfo.fee_split)
                    )
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.timeline")) + " "),
          ]),
          _c("div", { staticClass: "line-bottom-1px" }),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.payin_created"))),
            ]),
            _c("span", { staticClass: "content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.payin_completed"))),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c(
              "span",
              { staticClass: "item-left", staticStyle: { color: "#4B5567" } },
              [_vm._v(_vm._s(_vm.merchantInfo.transaction_create_time))]
            ),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.transaction_return_time)),
            ]),
          ]),
          _vm.merchantInfo.transaction_status ===
          _vm.TRANSACTION_STATUS["success"]
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("data.estimated_settlement_time"))),
                ]),
                _c("span", { staticClass: "content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("data.actual_settlement_time"))),
                ]),
              ])
            : _vm._e(),
          _vm.merchantInfo.transaction_status ===
          _vm.TRANSACTION_STATUS["success"]
            ? _c("div", { staticClass: "item" }, [
                _c(
                  "div",
                  {
                    staticClass: "item-left",
                    staticStyle: { color: "#4B5567" },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.merchantInfo.estimated_settlement_time || "/"
                        )
                      ),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "content-gray" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.merchantInfo.actual_settlement_time || "/")
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.description")) + " "),
          ]),
          _c("div", { staticClass: "line-bottom-1px" }),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("customerService.transaction_id"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.transaction_id || "")),
            ]),
          ]),
          _vm.isDetailCountry("TH") &&
          _vm.merchantInfo.transaction_status === _vm.TRANSACTION_STATUS["void"]
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.void_transaction_id"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      (_vm.merchantInfo.trans_void_resp &&
                        _vm.merchantInfo.trans_void_resp.void_no) ||
                        ""
                    )
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("customerService.merchant_order_id"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.merchant_order_id || "")),
            ]),
          ]),
          _vm.$store.getters.isPii
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("operation.business_name"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(_vm.getRelatedInfo(_vm.merchantInfo, "business"))
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.$store.getters.isPii
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("operation.franchisee_name"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(_vm.getRelatedInfo(_vm.merchantInfo, "franchisee"))
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.$store.getters.isMX &&
          _vm.merchantInfo.channel_code === "POS_STATIC_EDC"
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("data.pos_machine_sn"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(_vm._s(_vm.merchantInfo.pay_data || "")),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("acceptPayments.static_qr_id"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.qr_stand_no || "")),
            ]),
          ]),
          _vm.merchantInfo.settlement_status &&
          _vm.merchantInfo.transaction_status ===
            _vm.TRANSACTION_STATUS["success"]
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("data.settlement_status"))),
                ]),
                _c("div", { staticClass: "content-gray" }, [
                  _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getTransactionSettlementStatusMap(
                            _vm.merchantInfo.settlement_status
                          ).label || ""
                        )
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.isDetailCountry("TH") &&
          _vm.merchantInfo.transaction_status === _vm.TRANSACTION_STATUS["void"]
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.void_complete_time"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      (_vm.merchantInfo.trans_void_resp &&
                        _vm.merchantInfo.trans_void_resp.void_complete_time) ||
                        ""
                    )
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.merchantInfo.channel_reference_no
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        _vm.$store.getters.isMX
                          ? "customerService.ph_invoice_no"
                          : "customerService.invoice_no"
                      )
                    )
                  ),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(_vm._s(_vm.merchantInfo.channel_reference_no || "")),
                ]),
              ])
            : _vm._e(),
          [2].includes(_vm.merchantInfo.pay_product_type)
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.payment_code"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(_vm._s(_vm.merchantInfo.pay_data || "")),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("merchant.payment_channel"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.channel_code || "")),
            ]),
          ]),
          _vm.merchantInfo.fail_reason
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("data.fail_reason"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(_vm._s(_vm.merchantInfo.fail_reason)),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("customerService.pay_card_no"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.desensitization_card_no || "")),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("customerService.pay_card_scheme"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.card_scheme || "")),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("customerService.pay_card_issuer"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.card_issuer || "")),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("merchantAccount.recipient_name"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(
                _vm._s(
                  _vm._f("strAesDecryptAndAsterisk")(
                    _vm.merchantInfo.payer_name || ""
                  )
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("merchantAccount.recipient_mobile"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(
                _vm._s(
                  _vm._f("strAesDecryptAndAsterisk")(
                    _vm.merchantInfo.payer_mobile || ""
                  )
                )
              ),
            ]),
          ]),
          _vm.merchantInfo.transaction_status === 2
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.refund_type"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getRefundTypeMap(
                        _vm.merchantInfo.refund_category || ""
                      )
                    )
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.merchantInfo.transaction_status === 2
            ? _c("div", { staticClass: "item" }, [
                _c(
                  "span",
                  { staticClass: "item-left content-blue" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("customerService.cumulative_amount_refunded")
                      ) + " "
                    ),
                    _c("el-tooltip", { attrs: { placement: "top" } }, [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("tips.cumulative_amount_refunded_tip")
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "span",
                        [
                          _c("svg-icon", {
                            staticClass: "icon-question",
                            attrs: { "icon-class": "icon-font-question" },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("toDivideWithDot")(
                        Math.abs(_vm.merchantInfo.total_refunded_amount) || ""
                      )
                    )
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.merchantInfo.transaction_status === 2
            ? _c("div", { staticClass: "item" }, [
                _c(
                  "span",
                  { staticClass: "item-left content-blue" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "customerService.remaining_refundable_order_amount"
                        )
                      ) + " "
                    ),
                    _c("el-tooltip", { attrs: { placement: "top" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: { width: "300px" },
                          attrs: { slot: "content" },
                          slot: "content",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("tips.remaining_refundable_amount_tip")
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "span",
                        [
                          _c("svg-icon", {
                            staticClass: "icon-question",
                            attrs: { "icon-class": "icon-font-question" },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("toDivideWithDot")(
                        Math.abs(_vm.merchantInfo.available_refund_amount) || ""
                      )
                    )
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.$store.getters.isID
            ? [
                _vm.compIsJTMerchant
                  ? _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "item-left content-blue" }, [
                        _vm._v(
                          _vm._s(_vm.$t("customerService.jt_issuer_name"))
                        ),
                      ]),
                      _c("span", { staticClass: "content-gray" }, [
                        _vm._v(_vm._s(_vm.merchantInfo.outer_pay_method)),
                      ]),
                    ])
                  : _vm._e(),
                _vm.comIsCargoMerchant
                  ? _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "item-left content-blue" }, [
                        _vm._v(
                          _vm._s(_vm.$t("customerService.aggregate_cod_Amount"))
                        ),
                      ]),
                      _c("span", { staticClass: "content-gray" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              _vm.merchantInfo.aggregate_cod_amount
                            )
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm.comIsCargoMerchant
                  ? _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "item-left content-blue" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("customerService.aggregate_cod_fee_amount")
                          )
                        ),
                      ]),
                      _c("span", { staticClass: "content-gray" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              _vm.merchantInfo.aggregate_cod_fee
                            )
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm.comIsCargoMerchant
                  ? _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "item-left content-blue" }, [
                        _vm._v(
                          _vm._s(_vm.$t("customerService.aggregate_frt_amount"))
                        ),
                      ]),
                      _c("span", { staticClass: "content-gray" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              _vm.merchantInfo.aggregate_frt_amount
                            )
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm.comIsCargoMerchant
                  ? _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "item-left content-blue" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("customerService.aggregate_frt_fee_amount")
                          )
                        ),
                      ]),
                      _c("span", { staticClass: "content-gray" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              _vm.merchantInfo.aggregate_frt_fee
                            )
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm.comIsCargoMerchant
                  ? _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "item-left content-blue" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "customerService.transaction_fee_charge_mode"
                            )
                          )
                        ),
                      ]),
                      _c("span", { staticClass: "content-gray" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getTransactionFeeChangeMode(
                              _vm.merchantInfo.fee_split_type
                            )
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm.$store.getters.isID || _vm.$store.getters.isPii
            ? _c("div", { staticClass: "item" }, [
                _c(
                  "span",
                  { staticClass: "item-left content-blue" },
                  [
                    _vm._v(_vm._s(_vm.$t("data.split_amount")) + " "),
                    _c("el-tooltip", { attrs: { placement: "top" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: { width: "300px" },
                          attrs: { slot: "content" },
                          slot: "content",
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("tips.split_amount_tips"))),
                          ]),
                        ]
                      ),
                      _c(
                        "span",
                        [
                          _c("svg-icon", {
                            staticClass: "icon-question",
                            attrs: { "icon-class": "icon-font-question" },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("toDivideWithDot")(
                        Math.abs(_vm.merchantInfo.already_split_amount) || ""
                      )
                    )
                  ),
                ]),
              ])
            : _vm._e(),
          _c(
            "el-tag",
            {
              staticClass: "payin-status tag-custom",
              attrs: {
                type: _vm.getPayTransactionStatusType(
                  _vm.merchantInfo.transaction_status
                ),
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.getPayTransactionStatusMap(
                      _vm.merchantInfo.transaction_status
                    )
                  )
              ),
            ]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }